<template>
    <div>
        <div>
            <v-snackbar :color="status" :timeout="callbackResponse.timeout" top v-model="snackbar">
                {{callbackResponse.message}}
                <v-btn @click="snackbar = false" dark text>Close</v-btn>
            </v-snackbar>
        </div>
        <div>
            <v-btn @click="updateReportData" class="float-right mt-10 custom-save-button" style="margin-bottom:10px">Save
            </v-btn>
            <h2 style="text-align:center">{{valueShow}} आ.ब.{{yearShow}} {{reportTitle}}</h2>
            <table class="table tbl">
                <thead>
                <tr>
                    <th rowspan="2">क्र सं</th>
                    <th rowspan="2">बजेट शिर्षक</th>
                    <th colspan="2">आ.व. २०७५।७६</th>
                    <th colspan="2">आ.व. २०७६।७७</th>
                </tr>
                <tr>
                    <th>आ.व. २०७५।७६</th>
                    <th>आ.व. २०७६।७७</th>
                    <th>आ.व. २०७५।७६</th>
                    <th>आ.व. २०७६।७७</th>
                </tr>
                </thead>
                <tr :key="staticHeader.sno" v-for="staticHeader in rowsData">
                    <td>{{staticHeader.sno}}</td>
                    <td v-if="staticHeader.isMainTitle" class="title    ">{{staticHeader.title}}</td>
                    <td v-else> {{staticHeader.title}}</td>
                    <td :key="index" v-for="(headerInput,index) in staticHeader.dataCount">
                        <v-text-field label="Amount" outlined type="number" v-model="staticHeader.inputData[index]"></v-text-field>
                    </td>
                </tr>

                <tfoot>
                <tr class="tfoot">
                    <td colspan="2"><b>Total</b></td>
                    <td :key="total" v-for="total in totals">
                        <b v-if="total.total>0">{{total.total}}</b>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'ReportComponent',
        watch: {
            "logData.companyID": {
                handler: async function (val) {
                    if (val) {
                        this.error = true;
                        this.listDDLData.departmentList = [];
                        this.logData.branch = [];
                        axios.get("Department/DDLDepartmentList", {
                            params: {CompanyID: val}
                        }).then(response => {
                            this.listDDLData.departmentList = response.data;
                        });
                    }
                },
                deep: true
            },
            "logData.departmentID": {
                handler: async function (val) {
                    if (val) {
                        this.error = true;
                        this.logData.department = [];
                        axios.get("Branch/DDLBranchList", {
                            params: {DepartmentID: val}
                        }).then(response => {
                            this.listDDLData.branchList = response.data;
                        });
                    }
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },
        props: ['ApiData'],
        components: {},
        data() {
            return {
                rowsData: [
                    {
                        sno: "1",
                        title: "title1",
                        inputData: [],
                        dataCount:4,
                        isMainTitle:1
                    },
                    {
                        sno: "2",
                        title: "title1",
                        inputData: [],
                        dataCount:4,
                        isMainTitle:0
                    },
                    {
                        sno: "3",
                        title: "title1",
                        inputData: [],
                        dataCount:4,
                        isMainTitle:0
                    }
                ],
                loglist: {
                    rows:[],

                    totalRecords: 10,
                    columns: [
                        {
                            label: 'Report ID',
                            field: 'reportID'
                        },
                        {
                            label: 'Report Log ID',
                            field: 'reportLogID'
                        },
                        {
                            label: 'Company Name',
                            field: 'companyName'
                        },
                        {
                            label: 'Department Name',
                            field: 'departmentName'
                        },
                        {
                            label: 'Branch Name',
                            field: 'branchName'
                        },
                        {
                            label: 'Year',
                            field: 'yearName'
                        }, {
                            label: 'Action',
                            field: 'actions'
                        },

                    ]
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: []
                },
                rowsHeader: [],
                snackbar: false,
                panel: [0],
                table: false,
                dialogCreate: false,
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: {
                    totalCount:4
        },
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                status: "success",
                logData: {
                    companyID: "",
                    departmentID: "",
                    branchID: "",
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: ""
            };
        },
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
        },
        mounted() {
            this.loadCrumb()
        },

        methods: {
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            setValue(data, type) {
                let selectedData = "";
                console.log(data, type)
                if (type == "Company") {
                    this.logData.departmentID = "";
                    this.logData.branchID = "";
                    var company = this.listDDLData.companyList.filter(function (item) {
                        return item.id === data;
                    });
                    selectedData = company[0].value;
                }
                if (type == "Department") {
                    this.logData.branchID = "";
                    var department = this.listDDLData.departmentList.filter(function (item) {
                        return item.id === data;
                    });
                    selectedData = department[0].value;
                }
                if (type == "Branch") {
                    var branch = this.listDDLData.branchList.filter(function (item) {
                        return item.id === data;
                    });
                    selectedData = branch[0].value;
                }
                this.setValueYear(this.logData.year)
                this.setAllValue = selectedData;
            },
            setValueYear(data) {
                var year = this.yearList.filter(function (item) {
                    return item.value === data;
                });
                this.setYearValue = year[0].id;
            },
            checkLogs(data) {
                console.log(data)
                if (data.branchID > 0) {
                    let branchYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.branchID === data.branchID;
                    });
                    if (branchYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (data.departmentID > 0) {
                    let departmentYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.departmentID === data.departmentID && item.branchID == null;
                    });
                    if (departmentYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    let companyYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.companyID === data.companyID && item.departmentID == null && item.branchID == null;
                    });
                    if (companyYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            updateData(data, checkLogStatus) {
                let companyID = data.companyID ? parseInt(data.companyID) : ""
                if (checkLogStatus) {
                    var ExistedLog = this.checkLogs(data);
                    if (ExistedLog) {
                        this.status = "warning"
                        this.snackbar = true
                        this.callbackResponse.message = "warning! Log Exist";
                        return false;
                    } else {
                        this.logData.reportLogID = 0;
                        this.logData.branchID = parseInt(data.branchID);
                        this.logData.companyID = companyID;
                        this.logData.departmentID = parseInt(data.departmentID);
                    }
                } else {
                    this.logData.reportLogID = parseInt(data.reportLogID);
                    this.logData.branchID = parseInt(data.branchID);
                    this.logData.companyID = companyID;
                    this.logData.departmentID = parseInt(data.departmentID);
                }
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.yearShow = this.setYearValue;
                    this.valueShow = this.setAllValue;
                    this.table = true
                    this.logData.year = data.year
                    this.getColsRow(this.logData)
                }
            },
            reset() {
                let reportID = this.logData.reportID;
                this.logData = {}
                this.logData.reportID = reportID
                this.$nextTick(() => {
                    this.$v.$reset()
                })
            },
            logBtnData(row, status, year) {
                console.log(row, status, year)
                if (row.branchID > 0) {
                    this.valueShow = row.branchName
                } else if (row.departmentID > 0) {
                    this.valueShow = row.departmentName
                } else {
                    this.valueShow = row.companyName
                }

                this.yearShow = row.yearName

                this.logData.companyID = row.companyID
                this.logData.departmentID = row.departmentID
                this.logData.branchID = row.branchID
                this.logData.year = year
                this.logData.reportLogID = row.reportLogID

                var data = {
                    "reportLogID": parseInt(row.reportLogID),
                    "year": year,
                    "branchID": row.branchID,
                    "companyID": row.companyID,
                    "departmentID": row.departmentID,
                    "reportID": row.reportID
                }
                this.table = true
                this.getColsRow(data)
            },
            getColsRow(data) {
                axios.post('ReportSettings/GetColsRows', data).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                })
            },
            reportLog(Details) {
                console.log(this.logData)
                this.$nextTick(() => {
                    this.$v.$reset()
                })
                var data = {};
                if (Details == undefined) {
                    data = {
                        reportID: this.logData.reportID
                    };
                } else {
                    let branchID = 0;
                    let companyID = 0;
                    let departmentID = 0;
                    if (Details.companyID != "" && Details.companyID != undefined) {
                        companyID = parseInt(Details.companyID)
                    }
                    if (Details.departmentID != "" && Details.departmentID != undefined) {
                        departmentID = parseInt(Details.departmentID)
                    }
                    if (Details.branchID != "" && Details.branchID != undefined) {
                        branchID = parseInt(Details.branchID)
                    }
                    data = {
                        reportID: parseInt(this.logData.reportID),
                        companyID: parseInt(companyID),
                        departmentID: parseInt(departmentID),
                        branchID: parseInt(branchID),
                        year: Details.year
                    }
                }

                axios.post("ReportSettings/GetReportLogs", data).then(response => {
                    this.loglist.rows = response.data
                })
            },
            loadCrumb() {
                if (this.role == "Company") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                } else if (this.role == "Department") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.logData.departmentID = parseInt(this.userData.departmentID)
                } else if (this.role == "Branch" || this.role == "User") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.logData.departmentID = parseInt(this.userData.departmentID)
                    this.logData.branchID = parseInt(this.userData.branchID)
                }
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })
                this.reportLog()
                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                })

                axios.get('Company/DDLCompanyList').then(response => {
                    this.listDDLData.companyList = response.data
                })

                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.userData.dashBoardBranchUser}`,
                        exact: true
                    },
                    {
                        text: 'Profile',
                        disabled: true,
                    },
                ]
            },
            nullTitle(title) {
                return title == null
            },
            updateReportData() {
                var tableFormData = [];
                this.rows.forEach(function (data) {
                    data.list.forEach(function (list) {
                        list.list.forEach(function (amount) {
                            if (parseFloat(amount.amount) > 0 || (amount.value != "")) {
                                amount.amount = parseFloat(amount.amount);
                                tableFormData.push(amount)
                            }

                        })
                    })
                })
                let formData = {
                    "companyID": this.logData.companyID,
                    "departmentID": this.logData.departmentID,
                    "branchID": this.logData.branchID,
                    "reportID": parseInt(this.logData.reportID),
                    "year": this.logData.year,
                    "list": tableFormData,
                    "reportLogID": this.logData.reportLogID == "" ? 0 : parseInt(this.logData.reportLogID)
                }
                axios.post("ReportSettings/InsertOrUpdateReportDataAsync", formData).then(response => {
                    if (response.data.success) {
                        this.logData.reportLogID = response.data.id;
                        console.log(response.data)
                        this.status = "success"
                        this.snackbar = true
                        this.callbackResponse.message = "Data updated successfully."
                        this.reportLog()
                    }
                })
            },
            calculateTotal: function () {
                //footer total
                let AllRows = [];

                this.rows.forEach(function (section) {
                    section.list.forEach(function (subsection) {
                        subsection.list.forEach(function (amount) {
                            if (parseFloat(amount.amount) > 0) {
                                AllRows.push(
                                    {
                                        "reportHeaderID": amount.reportHeaderID,
                                        "amount": parseFloat(amount.amount)
                                    });
                            }

                        })
                    })
                })
                this.totals.forEach(function (data) {
                    data.total = 0;
                    var match = AllRows.filter(function (item) {
                        return item.reportHeaderID === data.headerID;
                    }).reduce((total, amount) => {
                        return total + parseFloat(amount.amount)
                    }, 0);
                    data.total = match;
                })
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCrumb();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadCrumb();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadCrumb();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadCrumb();
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }
</style>
